import { inject, Service } from '@angular/core';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { GetDataOptions } from '@portal-core/data/common/models/get-data-options.model';
import { WebhookSubscriber } from '@portal-core/slack/models/webhook-subscriber.model';
import { WebhookSubscription } from '@portal-core/slack/models/webhook-subscription.model';
import { SlackWebhooksApiService } from '@portal-core/slack/services/slack-webhooks-api.service';
import { SlackWebhookSubscribersDataService } from '@portal-core/slack/services/slack-webhooks-subscribers-data.service';
import { Resettable } from '@portal-core/util/resettable.decorator';
import { Observable, tap } from 'rxjs';

@Service()
@Resettable()
export class SlackWebhooksService extends CollectionServiceBase<WebhookSubscriber> {
  private readonly slackWebhooksApiService = inject(SlackWebhooksApiService);


  constructor() {
    super(inject(SlackWebhookSubscribersDataService));
  }

  // Subscribers
  getSubscribers$(licenseId: number, options: GetDataOptions = null): Observable<WebhookSubscriber[]> {
    return this.getDataListItems$('Licenses', licenseId, {
      fetch: () => this.slackWebhooksApiService.getSubscribers$(licenseId)
    }, options);
  }

  addSubscriber$(newWebhookSubscriber: WebhookSubscriber): Observable<WebhookSubscriber> {
    return this.slackWebhooksApiService.addSubscriber$(newWebhookSubscriber).pipe(
      tap(subscriber => {
        this.addItems$([subscriber]);
        this.addItemsToListById$('Licenses', subscriber.LicenseId, [subscriber]);
      })
    );
  }

  updateSubscriber$(webhookSubscriber: WebhookSubscriber): Observable<WebhookSubscriber> {
    return this.slackWebhooksApiService.updateSubscriber$(webhookSubscriber).pipe(
      tap(subscriber => this.updateItems$([subscriber]))
    );
  }

  deleteSubscriber$(subscriberId: number): Observable<void> {
    return this.slackWebhooksApiService.deleteSubscriber$(subscriberId).pipe(
      tap(() => this.deleteItems$([subscriberId]))
    );
  }

  // Subscribers' Subscriptions
  getSubscriptions$(subscriberId: number): Observable<WebhookSubscription[]> {
    return this.slackWebhooksApiService.getSubscriptions$(subscriberId);
  }

  addSubscription$(subscriberId: number, auditCategoryId: number): Observable<WebhookSubscription> {
    return this.slackWebhooksApiService.addSubscription$(subscriberId, auditCategoryId);
  }

  // deleteSubscription$(subscriberId: number, auditCategoryId: number): Observable<MadCloudResult> {
  //   return this.slackWebhooksApiService.deleteSubscription$(subscriberId, auditCategoryId);
  // }

  clearAllSubscriptions$(subscriberId: number): Observable<void> {
    return this.slackWebhooksApiService.clearAllSubscriptions$(subscriberId);
  }
}
